import { Link } from "react-router-dom";
import { formatApiDateTime } from "@modules/shared/utils/handle-date.utils";
import avatarDefault from "@assets/images/avatar-nobody.jpg";
import { FiEye } from "react-icons/fi";

const isNewPackage = (createdAt: string): boolean => {
  if (!createdAt) return false;
  const created = new Date(createdAt);
  const now = new Date();
  const diffDays = (now.getTime() - created.getTime()) / (1000 * 60 * 60 * 24);
  return diffDays < 3;
};

export function PackageTableRow({ pkg, modal }: any) {
  const isNew = isNewPackage(pkg.created_at);

  return (
    <tr>
      <td className="fw-semibold" title={pkg.title}>
        {pkg.title.length > 30 ? pkg.title.slice(0, 20) + "…" : pkg.title}
        {isNew && (
          <span className="badge ms-2" style={{ backgroundColor: "#E55921" }}>
            New
          </span>
        )}
      </td>

      <td title={pkg.categories}>
        {pkg.categories.length > 20
          ? pkg.categories.slice(0, 20) + "…"
          : pkg.categories}
      </td>

      <td>
        <Link
          to={`/trainers/${pkg.trainer_id}`}
          className="d-flex align-items-center text-decoration-none"
        >
          <img
            src={pkg.trainer_avatar || avatarDefault}
            alt={pkg.trainer_name}
            width={40}
            height={40}
            className="rounded-circle me-2"
            style={{ objectFit: "cover" }}
          />
          <span>
            {pkg.trainer_name.length > 25
              ? pkg.trainer_name.slice(0, 25) + "…"
              : pkg.trainer_name}
          </span>
        </Link>
      </td>

      <td>
        <span className={`badge ${pkg.is_active ? "bg-primary" : "bg-danger"}`}>
          {pkg.is_active ? "Public" : "Hidden"}
        </span>
      </td>

      <td>
        <span
          className={`badge ${pkg.verified_package ? "bg-success" : "bg-warning text-dark"}`}
        >
          {pkg.verified_package ? "Approved" : "Pending"}
        </span>
      </td>

      <td>{formatApiDateTime(pkg.created_at)}</td>

      <td>
        <button
          className="btn btn-icon btn-pills btn-soft-primary"
          onClick={(e) => {
            e.currentTarget.blur();
            modal.openDetail(pkg);
          }}
        >
          <FiEye />
        </button>
      </td>
    </tr>
  );
}
